import React from "react";
import {
  Box,
  Typography,
  Stack,
  Tooltip,
  IconButton,
  Divider,
  Chip,
} from "@mui/material";
import { StyledCard } from "../../common/StyledComponents";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import BarcodeIcon from "@mui/icons-material/QrCode2";

const FiscalItemCard = ({ item, onEdit, onAdjust }) => {
  return (
    <StyledCard>
      <Box
        sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}
      >
        <Stack direction="row" spacing={1.5} alignItems="flex-start">
          <BarcodeIcon color="primary" sx={{ mt: 0.5 }} />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="h6" fontWeight="bold" noWrap>
              {item.name}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: "block", fontFamily: "monospace" }}
            >
              eTIMS Code: {item.itemCode || "PENDING"}
            </Typography>
          </Box>
        </Stack>

        <Divider sx={{ my: 1.5 }} />

        <Stack spacing={1.2} sx={{ flexGrow: 1 }}>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              Item Class:
            </Typography>
            <Typography variant="body2" fontWeight="500">
              {item.itemClassCode}
            </Typography>
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              Tax Code:
            </Typography>
            <Typography variant="body2" fontWeight="500">
              {item.taxCode}
            </Typography>
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              Unit Price:
            </Typography>
            <Typography variant="body2" fontWeight="bold" color="success.main">
              {Number(item.unitPrice).toLocaleString()}
            </Typography>
          </Box>

          {(item.typeCode === "1" || item.typeCode === "2") && (
            <Box mt={1}>
              <Chip
                label={`KRA Stock: ${item.stock}`}
                size="small"
                variant="outlined"
                color="primary"
              />
            </Box>
          )}
        </Stack>

        <Stack direction="row" justifyContent="flex-end" spacing={0.5} mt={2}>
          {/* Only show adjust stock if it's a physical good (1=Raw, 2=Finished) */}
          {(item.typeCode === "1" || item.typeCode === "2") && (
            <Tooltip title="Adjust Stock">
              <IconButton size="small" onClick={onAdjust} color="info">
                <SyncAltIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip title="Edit Item Config">
            <IconButton size="small" onClick={onEdit} color="secondary">
              <EditOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      </Box>
    </StyledCard>
  );
};
export default FiscalItemCard;
